<template>
  <div class="map_wrapper" :class="{ with_sidebar: showSidebar }">
    <GmapMap
      ref="mapRef"
      :center="center"
      :zoom="zoom"
      map-type-id="roadmap"
      :options="mapOptions"
      style="height: 100%; width: 100%"
    >
      <GmapMarker
        v-for="delegate in delegates"
        :key="`delegate-${delegate.id}`"
        :position="{ lat: delegate.lat, lng: delegate.lng }"
        :icon="getDelegateIcon(delegate)"
        :title="delegate.name"
        @click="$emit('delegate-click', delegate)"
      />

      <GmapMarker
        v-for="group in distributionPointGroups"
        :key="`point-group-${group.key}`"
        :position="group.position"
        :icon="getDistributionIcon(group)"
        :title="getGroupTitle(group)"
        @click="$emit('distribution-group-click', group)"
      />
    </GmapMap>

    <delegates-tracking-bar
      :delegate="trackingDelegate"
      :default-avatar="defaultAvatar"
      @stop="$emit('stop-tracking')"
      @open-delegate="$emit('open-delegate', $event)"
    />
  </div>
</template>

<script>
import DelegatesTrackingBar from "./DelegatesTrackingBar.vue";
import {
  createDelegateMarkerIcon,
  createDistributionPointMarkerIcon,
  getDistributionPointLabel,
  groupDistributionPointsByLocation,
} from "../utils/delegatesMapHelpers";

export default {
  name: "DelegatesMap",

  components: {
    DelegatesTrackingBar,
  },

  props: {
    delegates: {
      type: Array,
      default: () => [],
    },
    distributionPoints: {
      type: Array,
      default: () => [],
    },
    center: {
      type: Object,
      required: true,
    },
    zoom: {
      type: Number,
      default: 10,
    },
    mapOptions: {
      type: Object,
      default: () => ({}),
    },
    trackingDelegate: {
      type: Object,
      default: null,
    },
    defaultAvatar: {
      type: String,
      required: true,
    },
    showSidebar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    distributionPointGroups() {
      return groupDistributionPointsByLocation(this.distributionPoints);
    },
  },

  methods: {
    getMapInstance() {
      return this.$refs.mapRef?.$mapObject;
    },

    getDelegateIcon(delegate) {
      const isTracking =
        this.trackingDelegate && this.trackingDelegate.id === delegate.id;
      return createDelegateMarkerIcon(delegate, isTracking);
    },

    getDistributionIcon(group) {
      return createDistributionPointMarkerIcon(group.count);
    },

    getGroupTitle(group) {
      if (group.count === 1) {
        return getDistributionPointLabel(group.points[0]);
      }
      return group.points.map(getDistributionPointLabel).join(" | ");
    },
  },
};
</script>
